import { createActions } from 'redux-actions'
import { get } from '../Infrastructure/Network'

export const {
  getStatisticsRequested,
  getStatisticsSucceeded,
  getStatisticsRejected,
} = createActions({
  getStatisticsRequested: () => ({}),
  getStatisticsSucceeded: (html: string) => html,
  getStatisticsRejected: () => ({}),
})

export const getStatistics = () =>
  get({
    url: '/statistics/html',
    initiated: getStatisticsRequested,
    fulfilled: getStatisticsSucceeded,
    rejected: getStatisticsRejected,
  })
